module.exports = __webpack_public_path__ + "img/AK0093-PK.b9b5c860.jpg";